import { makeStyles, Box, Paper } from "@material-ui/core";
import React, { useState } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";

import GeneralSettings from "./components/GeneralSettings";
//import FinancialManagement from "./components/FinancialManagementBackup";
import ProjectManagement from "./components/ProjectManagement";
import ResourceManagement from "./components/ResourceManagement";
import FinancialManagement from "./components/FinancialManagement";
import {
  SideSettingsIcon,
  ProjectManagementIcon,
  ResourceManagementIcon,
  FinancialDashboardIcon,
} from "../../shared-resources/SVGIcons";
import UserProfile from "./components/UserProfile";

const pagesData = [
  // {
  //   page: "GENERAL SETTINGS",
  //   route: "/settings/general-settings",
  //   children: [{ page: "Locations", isSelected: false }],
  // },
  // {
  //   page: "PROJECT MANAGEMENT",
  //   route: "/settings/project-management",
  //   children: [],
  // },
  // {
  //   page: "RESOURCE MANAGEMENT",
  //   route: "/settings/resource-management",
  //   children: [
  //     { page: "Skills", isSelected: false },
  //     { page: "Roles", isSelected: false },
  //     // { page: "Departments", isSelected: false },
  //     { page: "Hierarchy", isSelected: false },
  //     // { page: "Delegations", isSelected: false },
  //   ],
  // },
  {
    page: "FINANCIAL MANAGEMENT",
    route: "/settings/financial-management",
    children: [
      //{ page: "Versions", isSelected: false },
      { page: "Default Hours", isSelected: true },
      {
        page: "User Management",
        isSelected: false,
      },
      {
        page: "OT Types",
        isSelected: false,
      },
      // {
      //   page: "Access Management",
      //   isSelected: false,
      // },
    ],
  },
  /* {
    page: "FINANCIAL MANAGEMENT",
    route: "/settings/financial-management",
    children: [],
  },*/
];

const useStyles = makeStyles((theme) => ({
  componentStyles: {
    padding: "16px",
  },
  navBox: {
    marginRight: "24px",
  },
  navPaper: {
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "8px",
    height: "400px",
    width: "240px",
    padding: "12px 8px",
    textAlign: "center",
  },
  selectedNavItem: {
    padding: "8px",
    fontSize: "14px",
    // cursor: "pointer",
    color: "#ffffff",
    background: "#085F93",
    borderRadius: "8px",
    fontWeight: 600,
  },
  navItem: {
    padding: "8px",
    fontSize: "14px",
    // cursor: "pointer",
    color: "#085F93",
    fontWeight: 600,
  },
  svgIcon: {
    float: "left",
    margin: "6px 6px 0 0",
  },
  pageTitle: {
    float: "left",
    whiteSpace: "nowrap",
    margin: "6px 0 0 0",
  },
  selectedChildNav: {
    textAlign: "left",
    padding: "4px 0 4px 24px",
    cursor: "pointer",
    color: "#ffffff",
    fontWeight: 600,
    background: "#085F93",
    borderRadius: "4px",
  },
  childNav: {
    textAlign: "left",
    padding: "4px 0 4px 24px",
    cursor: "pointer",
    color: "#085F93",
    fontWeight: 600,
  },
}));

export default function Index() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const [pages, setPages] = useState(JSON.parse(JSON.stringify(pagesData)));

  const getSVGIcon = (item) => {
    if (item.page.toLowerCase() === "general settings")
      return SideSettingsIcon(
        location.pathname === "/settings/general-settings"
          ? "#ffffff"
          : "#085F93",
      );
    else if (item.page.toLowerCase() === "financial management")
      return FinancialDashboardIcon(
        location.pathname === "/settings/financial-management"
          ? "#ffffff"
          : "#085F93",
      );
    else if (item.page.toLowerCase() === "resource management")
      return ResourceManagementIcon(
        location.pathname === "/settings/resource-management"
          ? "#ffffff"
          : "#09659c",
        location.pathname === "/settings/resource-management"
          ? "#ffffff"
          : "#085F93",
      );
    else if (item.page.toLowerCase() === "versions")
      return SideSettingsIcon(
        location.pathname === "/settings/financial-management"
          ? "#ffffff"
          : "#09659c",
        location.pathname === "/settings/financial-management"
          ? "#ffffff"
          : "#085F93",
      );
    return ProjectManagementIcon(
      location.pathname === "/settings/project-management"
        ? "#ffffff"
        : "#085F93",
    );
  };

  const onTabSelect = (item) => {
    if (item.children.length > 0) {
      const changeData = JSON.parse(JSON.stringify(pages));
      changeData.forEach((pageItem) => {
        pageItem.children.forEach((childItem) => {
          childItem.isSelected = false;
        });
      });
      setPages(changeData);
    }
    history.push(item.route);
  };

  const onChildNavClick = (parent, item) => {
    const changeData = JSON.parse(JSON.stringify(pages));
    changeData.forEach((pageItem) => {
      if (pageItem.page === parent.page) {
        pageItem.children.forEach((childItem) => {
          if (childItem.page === item.page) childItem.isSelected = true;
          else childItem.isSelected = false;
        });
      }
    });
    setPages(changeData);
  };

  return (
    <div className={classes.componentStyles}>
      <Box style={{ marginTop: "12px" }} display="flex" flexDirection="row">
        <Box className={classes.navBox}>
          <Paper elevation={0} className={classes.navPaper}>
            {pages.map((item, i) => (
              <>
                <div
                  className={`${
                    location.pathname === item.route
                      ? classes.selectedNavItem
                      : classes.navItem
                  } clearfix`}
                  //  onClick={() => onTabSelect(item)}
                >
                  <span className={classes.svgIcon}>{getSVGIcon(item)}</span>
                  <span className={classes.pageTitle}>{item.page}</span>
                </div>
                {item.children.length > 0 &&
                  location.pathname === item.route && (
                    <div style={{ marginTop: "12px" }}>
                      {item.children.map((val, i) => (
                        <div
                          className={
                            val.isSelected
                              ? classes.selectedChildNav
                              : classes.childNav
                          }
                          onClick={() => onChildNavClick(item, val)}
                        >
                          {val.page}
                        </div>
                      ))}
                    </div>
                  )}
              </>
            ))}
          </Paper>
        </Box>
        <Box style={{ width: "100%", minWidth: 0 }}>
          <Switch>
            <Route path="/settings/general-settings">
              <GeneralSettings
                page={pages.filter((val) => val.page === "GENERAL SETTINGS")[0]}
              />
            </Route>
            <Route path="/settings/project-management">
              <ProjectManagement />
            </Route>
            <Route path="/settings/resource-management">
              <ResourceManagement
                page={
                  pages.filter((val) => val.page === "RESOURCE MANAGEMENT")[0]
                }
              />
            </Route>
            {/*<Route path="/settings/financial-management">
              <FinancialManagement />
            </Route>*/}
            <Route path="/user-profile">
              <UserProfile />
            </Route>
            <Route path="/settings/financial-management">
              <FinancialManagement
                page={
                  pages.filter((val) => val.page === "FINANCIAL MANAGEMENT")[0]
                }
              />
            </Route>
          </Switch>
        </Box>
      </Box>
    </div>
  );
}
